import React from 'react';
import { WidgetPanelDetailProps } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanel';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';

import { buildData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { toLiquidityRequestUid } from 'widgets/liquiditySummary/store/data/LiquiditySummaryStreamRequest';
import { computePredictedRemainingVolume } from '../../../liquiditySummary/liquiditySummaryData';

export interface WidgetPanelLiquiditySummaryProps
    extends WidgetPanelDetailProps {
    mode: 'streamData' | 'data';
}

export default function WidgetPanelLiquiditySummary(
    props: WidgetPanelLiquiditySummaryProps
) {
    const { mode, exchangeRate, state, selection } = props;

    const symbolQuantity = selection.selectedSymbolQuantity;

    if (!symbolQuantity) {
        return <></>;
    }

    const { symbol, qty } = symbolQuantity;

    const requestUid = toLiquidityRequestUid(symbol, {}, qty);
    const streamData = state.state.streams.data.liquidity[requestUid]?.data;
    const data = buildData(streamData, exchangeRate);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (streamData as any)['calculated predicted remaining'] =
        computePredictedRemainingVolume(streamData);

    if (mode === 'streamData') {
        return <JsonPanel data={streamData} />;
    }

    return (
        <div className="widget-panel">
            <div className="title">Symbol Capsule Data</div>
            <div className="field">
                <span className={'label'}>Symbol:</span>
                {symbol}
            </div>
            <div className="field">
                <span className="label">Request Uid:</span>
                {requestUid}
            </div>
            <JsonPanel data={data} />
        </div>
    );
}

export function addLiquiditySummaryPanes(
    detailProps: WidgetPanelDetailProps,
    panes: { menuItem: string; render: () => JSX.Element }[]
) {
    const render = () => (
        <WidgetPanelLiquiditySummary {...detailProps} mode="data" />
    );
    panes.push({
        menuItem: 'Data',
        render,
    });

    const renderTs = () => (
        <WidgetPanelLiquiditySummary {...detailProps} mode="streamData" />
    );
    panes.push({
        menuItem: 'Stream',
        render: renderTs,
    });
}
